import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.707 1.85c.49.372.9.84 1.205 1.376.3.51.98 1.928.361 2.73-.7.904-2.728 1.21-2.728 2.044 0 .628.889 1.344 1.364 2.045a2.433 2.433 0 010 2.728 2.543 2.543 0 01-.882.841M13.91 3.382a16.228 16.228 0 01-3.865 1.209c-.712.05-.818-.535-1.363-1.364-.409-.622-1.364-1.4-1.364-2.045a2.1 2.1 0 01.089-.66",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 15.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.782 8.616c.029 2.1-2.708 4.725-4.1 4.157-1.22-.5-.36-1.458-.672-4.157C7.88 7.494 9.078 6.57 10.4 6.57a2.244 2.244 0 012.382 2.045v0z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }